/* =========================================================================
   Article Table of Contents (jQuery version)
   -------------------------------------------------------------------------
   Rewritten to fix the bug where clicking a TOC link far down the page
   would highlight the WRONG (earlier) heading as active.

   Root cause of the old bug:
   - Native `scrollIntoView({behavior:'smooth'})` has no reliable "finished"
     event across browsers, so the old code guessed with a fixed setTimeout
     (1200ms). Long scrolls took longer than that, so the scroll-spy lock
     was released before the scroll animation actually finished, causing
     updateScrollSpy() to run mid-scroll and mark the wrong heading active.

   Fix in this version:
   - We scroll manually with jQuery's `$('html, body').animate({scrollTop}, ...)`
     which gives a guaranteed `complete` callback fired exactly when the
     scroll animation ends. The scroll-spy lock is released in that
     callback -- no timing guesswork needed.
   ========================================================================= */

(function ($) {
    'use strict';

    function initToc() {
        var $articleBody = $('.Article__Body');
        if ($articleBody.length === 0) return;

        var $headings = $articleBody.find('h1, h2, h3, h4, h5, h6').filter(function () {
            return $.trim($(this).text()).length > 0;
        });

        if ($headings.length === 0) return;

        var $tocContainer = $('.Article__TocContainer');
        var $tocWrapper = $('.Article__TocWrapper');
        var $tocNav = $('.Article__TocNav');
        var $wrapper = $('.Article__Wrapper');
        var $activeTitleEl = $tocContainer.find('.Article__TocActiveTitle');

        if ($tocContainer.length === 0 || $tocWrapper.length === 0 || $tocNav.length === 0) return;

        $wrapper.addClass('Article__Wrapper--withToc');
        $tocContainer.show();

        var $window = $(window);
        var $html = $('html, body');

        var lastActiveIndex = -1;
        var isScrollingClick = false;
        var scrollAnimSpeed = 500; // ms, adjust to taste

        // ---------------------------------------------------------------
        // Helpers
        // ---------------------------------------------------------------

        // Prefer theme CSS vars; fall back to measured sticky header section height
        function getHeaderHeight() {
            var rootStyle = getComputedStyle(document.documentElement);
            var cssHeaderHeight = parseFloat(rootStyle.getPropertyValue('--header-height'));
            var useStickyHeader = parseFloat(rootStyle.getPropertyValue('--use-sticky-header'));

            if (!isNaN(cssHeaderHeight) && cssHeaderHeight > 0) {
                // If header is not sticky, it scrolls away — no need to offset for it
                if (!isNaN(useStickyHeader) && useStickyHeader === 0) {
                    return 0;
                }
                return cssHeaderHeight;
            }

            var $headerSection = $('#shopify-section-header, .shopify-section--header').first();
            if ($headerSection.length && $headerSection.outerHeight() > 0 && $headerSection.outerHeight() < 200) {
                return $headerSection.outerHeight();
            }

            return 80;
        }

        function getArticleToolbarHeight() {
            var $toolbar = $('.ArticleToolbar');
            if ($toolbar.length === 0 || !$toolbar.hasClass('is-visible')) return 0;
            return $toolbar.outerHeight() || 0;
        }

        function isMobileToc() {
            return $window.width() < 1024;
        }

        function getMobileTocBarHeight() {
            var $headerEl = $tocContainer.find('.Article__TocHeader');
            // Header row + container vertical padding (12px * 2)
            return ($headerEl.length ? $headerEl.outerHeight() : 24) + 24;
        }

        // Offset for sticky chrome above content (header + toolbar / mobile TOC bar)
        function getStickyOffset() {
            if (isMobileToc()) {
                // Always use collapsed bar height so expand/collapse animation doesn't skew scroll
                return getHeaderHeight() + getMobileTocBarHeight() + 8;
            }
            return getHeaderHeight() + getArticleToolbarHeight() + 24;
        }

        function updateActiveTitle(index) {
            if ($activeTitleEl.length === 0) return;
            if (index >= 0 && index < $headings.length) {
                var activeText = $($headings[index]).text().trim();
                $activeTitleEl.text(activeText).show();
            } else {
                $activeTitleEl.text('').hide();
            }
        }

        function slugify(text) {
            return text
                .toString()
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .replace(/[^\w\-]+/g, '')
                .replace(/\-\-+/g, '-')
                .replace(/^-+/, '')
                .replace(/-+$/, '');
        }

        // ---------------------------------------------------------------
        // Build TOC links
        // ---------------------------------------------------------------

        var $links = $();

        $headings.each(function (idx) {
            var $heading = $(this);
            var slug = $heading.attr('id') || slugify($heading.text()) || 'heading';
            var uniqueId = slug;
            var counter = 1;

            while (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== $heading[0]) {
                uniqueId = slug + '-' + counter;
                counter++;
            }
            $heading.attr('id', uniqueId);

            var $link = $('<a>', {
                href: '#' + uniqueId,
                'class': 'Article__TocLink toc-level-' + this.tagName.toLowerCase(),
                text: $heading.text().trim()
            });

            $link.on('click', function (e) {
                e.preventDefault();

                var $target = $('#' + uniqueId);
                if ($target.length === 0) return;

                // Collapse first on mobile so offset uses the compact sticky bar height
                if (isMobileToc()) {
                    $tocContainer.removeClass('is-expanded');
                    $tocContainer.find('.Article__TocToggle').attr('aria-expanded', 'false');
                    $tocNav.css('max-height', '');
                }

                // Immediately mark this link active and lock scroll-spy
                // updates until the programmatic scroll finishes.
                isScrollingClick = true;
                $links.removeClass('is-active');
                $link.addClass('is-active');
                lastActiveIndex = idx;
                updateActiveTitle(idx);

                var offset = getStickyOffset();
                var targetTop = $target.offset().top - offset;

                history.pushState(null, null, '#' + uniqueId);

                // Deterministic scroll: jQuery's `complete` callback fires
                // exactly when the animation is done, so we release the
                // scroll-spy lock at the right moment -- no fixed-timeout
                // guessing, no risk of firing mid-scroll.
                $html.stop(true).animate(
                    { scrollTop: targetTop },
                    scrollAnimSpeed,
                    function () {
                        isScrollingClick = false;
                        updateScrollSpy();
                    }
                );
            });

            $tocNav.append($link);
        });

        $links = $tocNav.find('.Article__TocLink');

        // ---------------------------------------------------------------
        // Toggle button (mobile expand/collapse)
        // ---------------------------------------------------------------

        var $toggleButton = $tocContainer.find('.Article__TocToggle');
        if ($toggleButton.length) {
            $toggleButton.on('click', function () {
                var isExpanded = $tocContainer.toggleClass('is-expanded').hasClass('is-expanded');
                $(this).attr('aria-expanded', isExpanded ? 'true' : 'false');
                updateStickyPosition();

                if (isExpanded && lastActiveIndex >= 0) {
                    var $activeLink = $links.eq(lastActiveIndex);
                    // Wait for expand max-height to apply before measuring visibility
                    requestAnimationFrame(function () {
                        scrollActiveTocIntoView($activeLink);
                    });
                }
            });
        }

        // ---------------------------------------------------------------
        // Scroll spy
        // ---------------------------------------------------------------

        function scrollActiveTocIntoView($activeLink) {
            if (!$activeLink || $activeLink.length === 0) return;

            // Mobile: only when TOC is expanded (nav is scrollable)
            if (isMobileToc() && !$tocContainer.hasClass('is-expanded')) {
                return;
            }

            var $scrollParent = isMobileToc() ? $tocNav : $tocWrapper;
            if ($scrollParent.length === 0 || $scrollParent[0].scrollHeight <= $scrollParent[0].clientHeight) {
                return;
            }

            var parentRect = $scrollParent[0].getBoundingClientRect();
            var linkRect = $activeLink[0].getBoundingClientRect();
            var isOutOfView = linkRect.top < parentRect.top + 4 || linkRect.bottom > parentRect.bottom - 4;

            if (isOutOfView) {
                $activeLink[0].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
            }
        }

        function updateScrollSpy() {
            if (isScrollingClick) {
                return; // skip updating while a programmatic click-scroll is in progress
            }

            var scrollPosition = $window.scrollTop();
            var offset = getStickyOffset() + 26;

            var activeIndex = -1;
            var maxScroll = $(document).height() - $window.height();
            var isAtBottom = scrollPosition >= maxScroll - 15;

            if (isAtBottom) {
                // When at the bottom, select the last heading that is visible in the viewport
                for (var i = $headings.length - 1; i >= 0; i--) {
                    var rect = $headings[i].getBoundingClientRect();
                    if (rect.top >= offset - 50 && rect.top <= $window.height()) {
                        activeIndex = i;
                        break;
                    }
                }
                if (activeIndex === -1) {
                    activeIndex = $headings.length - 1;
                }
            } else {
                // Standard scroll spy: last heading that has crossed the threshold
                for (var j = 0; j < $headings.length; j++) {
                    var headingTop = $($headings[j]).offset().top;
                    if (scrollPosition >= headingTop - offset) {
                        activeIndex = j;
                    } else {
                        break;
                    }
                }
            }

            $links.each(function (idx) {
                $(this).toggleClass('is-active', idx === activeIndex);
            });

            // Auto-scroll TOC box only when the active item changes
            if (activeIndex !== lastActiveIndex) {
                lastActiveIndex = activeIndex;
                if (activeIndex >= 0) {
                    scrollActiveTocIntoView($links.eq(activeIndex));
                }
                updateActiveTitle(activeIndex);
            }
        }

        // ---------------------------------------------------------------
        // Sticky positioning
        // ---------------------------------------------------------------

        function updateStickyPosition() {
            var headerHeight = getHeaderHeight();
            var bottomGap = 24;

            if (!isMobileToc()) {
                var stickyTop = headerHeight + getArticleToolbarHeight() + 24;
                $tocContainer.css('top', '');
                $tocWrapper.css({
                    top: stickyTop + 'px',
                    'max-height': 'calc(100vh - ' + (stickyTop + bottomGap) + 'px)'
                });
                $tocNav.css('max-height', '');
                return;
            }

            // Mobile: stick the whole TOC card under the site header
            var mobileStickyTop = headerHeight + 8;
            $tocWrapper.css({ top: '', 'max-height': '' });
            $tocContainer.css('top', mobileStickyTop + 'px');

            if ($tocContainer.hasClass('is-expanded')) {
                var $headerEl = $tocContainer.find('.Article__TocHeader');
                var headerBlock = $headerEl.length ? $headerEl.outerHeight() + 24 : 48;
                var available = $window.height() - mobileStickyTop - headerBlock - 16;
                $tocNav.css('max-height', Math.max(120, Math.min(available, $window.height() * 0.4)) + 'px');
            } else {
                $tocNav.css('max-height', '');
            }
        }

        // ---------------------------------------------------------------
        // Manual-scroll interruption
        // If the user scrolls/interacts manually while a click-triggered
        // animation is still running, stop the animation and release the
        // lock immediately so scroll-spy takes back over right away.
        // ---------------------------------------------------------------

        function interruptClickScroll() {
            if (isScrollingClick) {
                $html.stop(true); // stops the animate(); its `complete` callback
                                   // will NOT fire, so release the lock here instead
                isScrollingClick = false;
                updateScrollSpy();
            }
        }

        // ---------------------------------------------------------------
        // Event bindings
        // ---------------------------------------------------------------

        $window.on('scroll', function () {
            updateScrollSpy();
            updateStickyPosition();
        });

        $window.on('resize', function () {
            updateScrollSpy();
            updateStickyPosition();
        });

        // A real user-initiated wheel/touch/key scroll should cut short any
        // programmatic scroll animation still in flight from a TOC click.
        $window.on('wheel touchmove', interruptClickScroll);
        $window.on('keydown', function (e) {
            var keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', ' ', 'Home', 'End'];
            if (keys.indexOf(e.key) !== -1) {
                interruptClickScroll();
            }
        });

        // ---------------------------------------------------------------
        // Init
        // ---------------------------------------------------------------

        updateScrollSpy();
        updateStickyPosition();
    }

    $(function () {
        initToc();
    });
})(jQuery);